import { useMemo, useState } from 'react';

export function useProductFilters(items, pageSize) {
  const [filters, setFilters] = useState({
    search: '',
    category: '',
    vendor: '',
    type: '',
    sortField: '',
    sortOrder: 'asc',
    page: 1,
  });

  const filtered = useMemo(() => {
    return items
      .filter((i) => {
        const q = filters.search.toLowerCase();

        const matchesSearch =
          !q ||
          i.name?.toLowerCase().includes(q) ||
          i.category?.toLowerCase().includes(q) ||
          i.vendorName?.toLowerCase().includes(q);

        const matchesCategory = !filters.category || i.category === filters.category;

        const matchesVendor = !filters.vendor || i.vendorName === filters.vendor;

        const matchesType = !filters.type || i.type === filters.type;

        return matchesSearch && matchesCategory && matchesVendor && matchesType;
      })
      .sort((a, b) => {
        if (a.isFavorite !== b.isFavorite) return b.isFavorite - a.isFavorite;
        // Unsorted, the API returns items in itemId (random UUID) order, which
        // scattered a just-added item onto an arbitrary page. Newest first.
        if (!filters.sortField) {
          return String(b.createdAt || '').localeCompare(String(a.createdAt || ''));
        }

        const va = a[filters.sortField];
        const vb = b[filters.sortField];

        if (va == null) return 1;
        if (vb == null) return -1;

        if (typeof va === 'number') {
          return filters.sortOrder === 'asc' ? va - vb : vb - va;
        }

        return filters.sortOrder === 'asc'
          ? String(va).localeCompare(String(vb))
          : String(vb).localeCompare(String(va));
      });
  }, [items, filters]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));

  const currentItems = filtered.slice((filters.page - 1) * pageSize, filters.page * pageSize);

  return {
    currentItems,
    filters,
    setFilters,
    pagination: {
      page: filters.page,
      totalPages,
      total: filtered.length,
      setPage: (page) => setFilters((f) => ({ ...f, page })),
    },
  };
}
